<template src="./resetPassword.html"></template>

<script>
import { ref, computed, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useToast } from "@/composables/UseToast";
import { verifica_reset_token, reimposta_password } from "@/api/api.auth";

export default {
    name: "ResetPassword",

    setup() {
        const router = useRouter();
        const route = useRoute();
        const toast = useToast();

        // ── Stato pagina: 'verifica' | 'form' | 'errore' | 'successo' ────────
        const stato = ref("verifica");
        const token = ref("");

        // ── Campi form ────────────────────────────────────────────────────────
        const formReset = ref(null);
        const password = ref("");
        const confermaPassword = ref("");
        const mostraPassword = ref(false);
        const mostraConferma = ref(false);
        const attesa = ref(false);

        // ── Requisiti visivi password ─────────────────────────────────────────
        const requisitiPassword = computed(() => [
            {
                testo: "Almeno 8 caratteri",
                soddisfatto: password.value.length >= 8,
            },
            {
                testo: "Almeno una lettera maiuscola",
                soddisfatto: /[A-Z]/.test(password.value),
            },
            {
                testo: "Almeno un carattere speciale (!@#$%^&*...)",
                soddisfatto: /[^a-zA-Z0-9]/.test(password.value),
            },
        ]);

        // ── Regole validazione ────────────────────────────────────────────────
        const regolePassword = [
            (v) => !!v || "Campo obbligatorio",
            (v) => v.length >= 8 || "Minimo 8 caratteri",
            (v) => /[A-Z]/.test(v) || "Almeno una lettera maiuscola",
            (v) => /[^a-zA-Z0-9]/.test(v) || "Almeno un carattere speciale",
        ];

        const regoleConferma = [
            (v) => !!v || "Campo obbligatorio",
            (v) => v === password.value || "Le password non coincidono",
        ];

        // ── Verifica token al mount ───────────────────────────────────────────
        onMounted(async () => {
            token.value = route.query.token || "";

            if (!token.value) {
                stato.value = "errore";
                return;
            }

            try {
                await verifica_reset_token(token.value);
                stato.value = "form";
            } catch {
                stato.value = "errore";
            }
        });

        // ── Submit nuova password ─────────────────────────────────────────────
        const submit = async () => {
            const { valid } = await formReset.value.validate();
            if (!valid) return;

            attesa.value = true;
            try {
                await reimposta_password({
                    token: token.value,
                    nuovaPassword: password.value,
                });
                stato.value = "successo";

                // Redirect automatico dopo 3 secondi
                setTimeout(() => vaiAlLogin(), 3000);
            } catch {
                toast.error("Errore durante il salvataggio. Il link potrebbe essere scaduto.");
                stato.value = "errore";
            } finally {
                attesa.value = false;
            }
        };

        const vaiAlLogin = () => router.push("/login");

        return {
            stato,
            formReset,
            password,
            confermaPassword,
            mostraPassword,
            mostraConferma,
            attesa,
            requisitiPassword,
            regolePassword,
            regoleConferma,
            submit,
            vaiAlLogin,
        };
    },
};
</script>

<style scoped>
.login-container {
    background: linear-gradient(135deg, #1E3A5F 0%, #14273F 100%);
}

.login-card {
    border-radius: 12px;
}

@media (max-width: 600px) {
    .login-card {
        border-radius: 0;
        min-height: 100vh;
    }
}
</style>